module.exports = __webpack_public_path__ + "img/photo-03.d740772f.webp";